<script>
    import { createEventDispatcher } from "svelte";

    export let type;
    export let disabled;
    const dispatch = createEventDispatcher();
    
    function handleClick () {
        dispatch("click");
    }
</script>

<button {type} {disabled} on:click={handleClick}>
    <slot></slot>
</button>

<style>
    button {
        padding: 0.8rem 1.6rem;
        border-radius: 0.5rem;
        border: none;
        background-color: #59A96A;
        color: #F0F0F0;
        position: relative;
        transition: background-color 200ms ease-in-out;
    }

    button:disabled {
        filter: grayscale(1);
    }

    button::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: 0.5rem;
        z-index: 1;
        box-shadow: inset 0 0 0 2px rgb(122, 189, 113), inset -1px -1px 0 rgb(43, 112, 45);
        opacity: 0;
        transition: opacity 300ms ease-out;
    }

    button:hover:not(:disabled),
    button:active:not(:disabled),
    button:focus:not(:disabled) {
        background-color: #439455;
    }

    button:focus-within {
        outline: 2px solid rgb(122, 164, 255);
    }

    button:active:not(:disabled)::after,
    button:focus-within:not(:disabled)::after,
    button:hover:not(:disabled)::after {
        opacity: 1;
    }
</style>